import styled from "styled-components"
import {greys} from "@irati/ui/src/global/colors"
import padding from "../../global/padding"

const PopUp = styled.div`
  padding: ${padding.base};
  height: ${(props) => props.height + 2}px;
  width: 292px;
  background-color: ${(props) => props.color};
  border: 1px solid ${greys.mediumLight};
  border-radius: 5px;
  z-index: 1000;
  position: absolute;
  color: white;
  text-transform: initial;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export default PopUp
